import { create } from "zustand";
import { persist } from "zustand/middleware";

// The only client-side state the Optimize tab owns: which game the partner
// "marked" in the overview strip. Per the spec the backend never stores it — it
// only drives which title the card previews and "Active since" lines use.
// Everything else lives on the server.

interface OptimizeUiStore {
  markedGameId: string | null;
  // the strip's "mark a title" hint has done its job once the partner has marked
  // anything, so it retires for good instead of nagging on every visit
  hintDismissed: boolean;
  setMarkedGame: (gameId: string | null) => void;
  // called on logout: the marked game belongs to the account that marked it,
  // and it is persisted, so it would otherwise leak into the next login
  reset: () => void;
}

export const useOptimizeStore = create<OptimizeUiStore>()(
  persist(
    (set) => ({
      markedGameId: null,
      hintDismissed: false,
      setMarkedGame: (gameId) => set({ markedGameId: gameId, hintDismissed: true }),
      reset: () => set({ markedGameId: null, hintDismissed: false }),
    }),
    { name: "optimize-ui" }
  )
);
